import React from "react";

import { Icon, PlainButton } from "@culturehq/components";
import { dates } from "app/utils";

interface MediaVersionHistoryElementProps {
  checked: boolean;
  createdAt: string;
  creatorName: string;
  original: boolean;
  draft: boolean;
  onDownload: () => void;
}

const MediaVersionHistoryElement: React.FC<MediaVersionHistoryElementProps> = ({
  createdAt, creatorName, original, draft, checked, onDownload
}) => (
  <div className="container">
    {checked && <Icon className="icon" icon="checkmark" />}
    <div className="description">
      <span className="updated">{dates.getHumanize(createdAt)} - {dates.format(createdAt, "MM/DD/YY hh:mm a")}</span>
      <span className="creator">
        {creatorName}
        {original && " (Original)"}
        {draft && <span className="autosave">{" "}(Draft)</span>}
      </span>
      <div />
    </div>
    {!draft && (
      <div className="version-download">
        <PlainButton className="button-version" onClick={onDownload}>
          <Icon icon="download" />
        </PlainButton>
      </div>
    )}
  </div>
);

export default MediaVersionHistoryElement;
